import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, of, switchMap } from 'rxjs';
import { CadHighwayModalComponent } from './cad-highway-modal/cad-highway-modal.component';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertComponent } from '../../alert/alert.component';
import { LoadingService } from '../../loading/loading.service';
import { MunicipalitiesService } from 'src/app/modules/services/municipalities/municipalities.service';
import { MatTableDataSource } from '@angular/material/table';
import { ModalComponent } from '../../modal/modal.component';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MoreFilterComponent } from './more-filter/more-filter.component';
import { NewHighwayModalComponent } from './new-highway-modal/new-highway-modal.component';
import { SegmentsTableComponent } from '../segments/segments-table/segments-table.component';
import { ModalController } from '@ionic/angular';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ImportModalComponent } from 'src/app/modules/shared/modals/import-modal/import-modal.component';
import { ImportValidationComponent } from 'src/app/modules/shared/modals/import-validation/import-validation.component';

@Component({
  selector: 'app-rodovias-abrangidas',
  templateUrl: './rodovias-abrangidas.component.html',
  styleUrls: ['./rodovias-abrangidas.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class RodoviasAbrangidasComponent implements OnInit {
  extensionTotal: number = 0;
  @Input() contractId: any
  @Input() cnpj:any;
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() dataSource = new MatTableDataSource<any>([]);
  searchControlHighwayHeader = new FormControl();
  descriptionHighwayHeader = new FormControl();
  selectedOptionMunicipios: any;
  filteredOptionsMunicipios: any[] = [];
  searchControlMunicipiosHeader = new FormControl();
  selectedOptionHighway: any;
  filteredOptionsHighway: any[] = [];

  cities: any[] = [];
  highways: any[] = [];

  displayedColumns1: string[] = [
    'rodovia',
    'extension',
    'actions',
  ];
  columnsToDisplay = ['name'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandedHighway: any | null;
  pageSize: number = 10;
  pageIndex: number = 1;
  totalPages: number = 1;
  totalElements: number = 1;
  searchControl = new FormControl();
  selectedOption: any;
  filteredOptions: any[] = [];
  nomeRodoviaFilter = '';
  nomeMunicipioFilter = '';
  @Input() isEditMode: boolean = false;
  screenWidth: number = 0;
  screenHeight: number = 0;
  sortState: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  constructor(
    private dialog: MatDialog,
    private highWayService: HighwaysService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private municipioService: MunicipalitiesService,
    private modalCtrl: ModalController,
    private segmentService: SegmentsService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    this.descriptionHighwayHeader.disabled;
    iconRegistry.addSvgIcon(
      'filter-icon',
      sanitizer.bypassSecurityTrustResourceUrl('assets/create-user/svgs/trailing-icon.svg')
    );
  }

  ngOnInit(): void {

    this.searchControlMunicipiosHeader.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => value && value?.trim().length > 0),
      switchMap(value => {

        return this.municipioService.getMunicipalities(0, '', '', '', value).pipe(
          catchError(() => of([]))
        );
      })
    ).subscribe((results: any) => {
      this.filteredOptionsMunicipios = results.content;
    });
    this.searchControlHighwayHeader.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => value && value?.trim().length > 0),
      switchMap(value => {

        return this.highWayService.getAll(0, '', '', value).pipe(
          catchError(() => {
            this.filteredOptionsHighway = [{ addNew: true }];
            return of([]);
          })
        )
      }
      )
    ).subscribe((results: any) => {
      this.filteredOptionsHighway = results.content;

      if (this.filteredOptionsHighway?.length === 0 || this.filteredOptionsHighway === undefined) {
        this.filteredOptionsHighway = []

        this.filteredOptionsHighway.push({ addNew: true });
      }
    });


    this.onGetAllHighway();
    this.onGetAllData()

    this.getScreenDimensions();
    window.addEventListener('resize', this.getScreenDimensions.bind(this));

  }
  getScreenDimensions() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  onOpenSegment(highWay: any) {

    let data = {
      highway: highWay,
      isEditMode: false,
      contract_id: this.contractId
    }

    const dialog = this.dialog.open(SegmentsTableComponent, {
      panelClass: ['segments-panel'],
      data: data
    })
  }

  addHighway() {
    let data = {
      isEditMode: false,
      contract_id: this.contractId
    }
    const dialog = this.dialog.open(NewHighwayModalComponent, {
      panelClass: ['new-highway-modal-panel'],
      data: data
    })

    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          let data = {
            highway: res,
            isEditMode: false,
            contract_id: this.contractId
          }

          this.onGetAllHighway();
          const dialogSegments = this.dialog.open(SegmentsTableComponent, {
            panelClass: ['segments-panel'],
            data: data
          })
          dialogSegments.afterClosed().subscribe({
            next: (res: any) => {
              this.onGetAllHighway();
            }
          })

        }

      }
    })

  }

  onGetAllHighway(pageIndex: number = 0) {
    this.loadingService.showLoading();
    this.highWayService.getHighwayContract(
      pageIndex,
      this.contractId,
      this.sortState.sortDirection,
      this.sortState.sortProperty,
      this.nomeRodoviaFilter,
      this.nomeMunicipioFilter
    ).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {


        const { content, pageSize, totalPages, totalElements, pageNumber } =
          res;
        this.dataSource.data = content
        this.pageSize = pageSize;
        this.totalPages = totalPages;
        this.totalElements = totalElements;
        this.pageIndex = pageNumber;

        this.extensionTotal = 0
        res.content.forEach((segment: any) => {
          this.extensionTotal += segment.totalExtensionKm
        });
      },
      error: (err: any) => {
        if (err.error.message === 'Nenhuma rodovia abrangida encontrada.') {
          this.dataSource.data = []
        } else {
          this.openSnackBar(err.error.message, 'error');
        }
      }
    })
  };
  openModalAddNewHighway() {

    let data = {
      isEditMode: false,

    }
    const dialog = this.dialog.open(CadHighwayModalComponent, {
      panelClass: ['filter-panel'],
      data: data
    })

    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.loadingService.showLoading();
          this.highWayService.createHighway(res).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {
              this.openSnackBar('Rodovia adicionada com sucesso.', 'sucess');

              this.onGetAllHighway();
            }, error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }
      }
    })
  }

  onHighwayEdited() {

    this.onGetAllHighway();

  }

  onFocusCity() {
    this.filteredOptionsMunicipios = this.cities;
  }
  onFocusHighway() {
    this.filteredOptionsHighway = this.highways;
  }
  openModalFilters() {

    const dialogRef = this.dialog.open(MoreFilterComponent, {
      panelClass: ['filter-panel'],
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.nomeMunicipioFilter = res.nomeMunicio
          this.nomeRodoviaFilter = res.nomeRodovia
          this.onGetAllHighway()
        }
      }
    })
  }

  onHighwayDeleted() {
    this.onGetAllHighway();
  }
  onOptionSelectedMunicipiosHeader(event: any) {
    this.selectedOptionMunicipios = event.option.value;
    // this.searchControl.setValue(, { emitEvent: false });
    this.searchControlMunicipiosHeader.setValue(this.selectedOptionMunicipios.description, { emitEvent: false });

    this.filteredOptionsMunicipios = [];
  }
  onOptionSelectedHighwayHeader(event: any) {

    this.selectedOptionHighway = event.option.value
    this.descriptionHighwayHeader.setValue(this.selectedOptionHighway.description, { emitEvent: false });
    this.searchControlHighwayHeader.setValue(this.selectedOptionHighway.name, { emitEvent: false });

    this.filteredOptionsHighway = [];
  }
  openDeleteDialog(id: string): void {
    const modalTitle: string = 'Excluir';
    const modalContent: string =
      'Você tem certeza que deseja excluir esta Rodovia?';

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: modalTitle,
        modalContent: modalContent,
        id: id,
      },
    });
  }

  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.highWayService.deleteHighway(this.contractId, id)
      .pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (res: any) => {
          this.onGetAllHighway()
          this.openSnackBar('Rodovia Deletada com sucesso.', 'sucess');
        }, error: (err: any) => {
          this.onGetAllHighway()
          this.openSnackBar(err.error.message, 'error');
        }
      })
  }

  editHighway(highway: any) {

    let data = {
      isEditMode: true,
      highWay: highway
    }
    const dialog = this.dialog.open(CadHighwayModalComponent, {
      panelClass: ['filter-panel'],
      data: data
    });

    dialog.afterClosed().subscribe({
      next: (res: any) => {

        if (res) {

          this.highWayService.editHighway(res, this.contractId, highway.id).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {

              this.onGetAllHighway()

              this.openSnackBar('Rodovia editada com sucesso.', 'sucess');
            }, error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }
      }
    })

  }
  onGetAllData() {

    this.municipioService.getMunicipalities(0, '', '', '', '').pipe(
      catchError(() => of([]))
    )
      .subscribe((results: any) => {
        this.cities = results.content;
      });
    this.municipioService.getMunicipalities(0, '', '', '', '').pipe(
      catchError(() => of([]))
    )
      .subscribe((results: any) => {
        this.cities = results.content;
      });

    this.highWayService.getAll(0, '', '', '').pipe(
      catchError(() => {
        this.highways = [{ addNew: true }];
        return of([]);
      })
    ).subscribe((results: any) => {
      this.highways = results.content;

      if (this.highways?.length === 0 || this.highways === undefined) {
        this.highways = []

        this.highways.push({ addNew: true });
      }
    });
  }
  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  pageChangeEvent(event: PageEvent) {
    if (this.pageIndex !== event.pageIndex) {
      this.onGetAllHighway(event.pageIndex)
    }
  }
  onSortChange(sortProperty: 'highwayName.name' |
    'city.description' |
    'totalExtensionKm'): void {


    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {

      this.sortState.sortDirection = 'asc';
    }
    this.sortState.sortProperty = sortProperty;

    this.onGetAllHighway();
  }

  addSegment(Highway: any) {
    this.loadingService.showLoading();

    this.segmentService.addSegment(this.selectedOption, Highway.id).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {

        this.openSnackBar('Segmento adicionado com sucesso.', 'sucess');
      },
      error: (err: any) => {
        this.openSnackBar(err.error.message, 'error');
      }
    })
  }

  onOptionSelectedHeader(event: any) {
    this.selectedOption = event.option.value;
    // this.searchControl.setValue(, { emitEvent: false });

    this.filteredOptions = [];
  }

  onSegmentAtt(Highway: any) {
    let data = {
      highway: Highway,
      isEditMode: false,
      contract_id: this.contractId,
      buttonInclusaoDisabled: this.buttonInclusaoDisabled,
      buttonExclusaoDisabled: this.buttonExclusaoDisabled,
      buttonEdicaoDisabled: this.buttonEdicaoDisabled
    }


    const dialog = this.dialog.open(SegmentsTableComponent, {
      panelClass: ['segments-panel'],
      data: data
    });

    dialog.afterClosed().subscribe({
      next: (res: any) => {
        this.onGetAllHighway()
        this.onGetAllData()
      }
    })
  }
  async openDialogHistoricoRodovia(contractId: string, highwayId: string) {

    const data = {
      type: 'rodovia',
      id: contractId,
      highwayId: highwayId,
      fieldMappings: {
        id: 'Id',
        city: 'Municipio',
        highway: 'Rodovia',
        description: 'Descrição',
        totalExtensionKm: 'Extensão'
      }
    }
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }

  openImportModal() {
    const data = {};
    const dialogRef = this.dialog.open(ImportModalComponent, {
      panelClass: ['anotation-panel'],
      data,
    });


    dialogRef.afterClosed().subscribe({
      next: (file: any) => {
        if (file) {
          // this.openModalImportValidation(mockDataValid, file);
          this.loadingService.showLoading();
          this.highWayService
            .validateImportHighway(this.contractId, file)
            .pipe(
              finalize(() => {
                this.loadingService.hideLoading();
              })
            )
            .subscribe({
              next: (res: any) => {
                this.openModalImportValidation(res, file);

                // this.openSnackBar('Rodovia importada com sucesso.', 'sucess');
              },
              error: (err: any) => {
                this.openSnackBar(err.error.message, 'error');
              },
            });
        }
      },
    });
  }
  openModalImportValidation(resp:any, file: any){

    const data = {
      resp: resp,
      file:file,
      from:'rodovia'
    };

    const dialogTableValidation = this.dialog.open(ImportValidationComponent, {

      width: '800px',
      height: '850px',
      data,
    });

    dialogTableValidation.afterClosed().subscribe({
      next: (res: any) => {
        if (res && !res.retry) {
          this.loadingService.showLoading();
          this.highWayService
            .importHighway(this.contractId, resp, file, this.cnpj)
            .pipe(
              finalize(() => {
                this.loadingService.hideLoading();
              })
            )
            .subscribe({
              next: (res: any) => {
                this.onGetAllHighway();
                this.openSnackBar('Importação finalizada com sucesso.', 'sucess');
              },
              error: (err: any) => {
                this.openSnackBar(err.error.message, 'error');
              },
            });
        }else{
          if(res.retry){
            this.openImportModal();
          }
        }
      },
    });
  }


}
